import { Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ISelectOption } from '../../models/utils/selectOption'
import { defaultFilterOption } from '../../utils'
import { useGetDataOnScroll } from '../getDataOnScrollProps/useGetDataOnScrollProps'
import { useLazyGetGovernmentListQuery } from '../../redux/api/handBooksApi/governmentApi'
import { EntGovernment } from '../../models/handBooks/government'
import { EntInitialFilterName } from '../../models/filters/initialFilterName'
import { getCookie } from 'typescript-cookie'

interface IProps {
	value?: number | null
	onChange?: (v: number) => void
	mode?: 'multiple'
}
const SelectGovernment = (props: IProps) => {
	const { t } = useTranslation()
	const [options, setOptions] = useState<ISelectOption[]>([])

	const [getData] = useLazyGetGovernmentListQuery()
	const { fetching, data, setData, setFetching, setFilter, scrollHandler, setCurrentPage } =
		useGetDataOnScroll<EntGovernment, EntInitialFilterName>({
			initialFilter: new EntInitialFilterName(),
			query: getData,
		})

	useEffect(() => {
		const options = Array.from(new Set(data)).map(a => {
			return {
				label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}`,
				value: a.id ?? '',
			}
		})
		setOptions(options)
	}, [data])

	const search = (value?: string) => {
		if (!value) return
		const filter = new EntInitialFilterName()
		filter.name = value
		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}
	const clear = () => {
		const filter = new EntInitialFilterName()
		filter.name = null
		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	return (
		<Select
			placeholder={t('msg.selectPlaceholder')}
			onClear={clear}
			showSearch
			allowClear
			mode={props.mode}
			defaultActiveFirstOption={false}
			onSearch={search}
			onPopupScroll={scrollHandler}
			loading={fetching}
			value={props.value}
			onChange={props.onChange}
			options={options}
			filterOption={defaultFilterOption}
			dropdownRender={menu => <Spin spinning={fetching}>{menu}</Spin>}
		/>
	)
}

export default SelectGovernment
